// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/plusjakartasans-variablefont_wght-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/plusjakartasans-variablefont_wght-webfont.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "jakarta";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
      format("woff");
  font-weight: normal;
  font-style: normal;
}

/* RESETS */
*,
*:before,
*:after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

button {
  border: none;
  background: none;
  font-family: inherit;
  font-size: inherit;
  width: auto;
  cursor: pointer;
}

img {
  width: auto;
}

fieldset {
  border: none;
}

input {
  cursor: pointer;
  width: 100%;
}

label {
  width: 100%;
}

/* Styles */
body {
  min-height: 100vh;
  font-family: "jakarta", Arial, Helvetica, sans-serif;
  font-size: 16px;

  /* ## Colors */

  /* ### Primary */

  --Lime: rgb(215, 218, 47);
  --Lime-darker: rgb(166, 168, 35);
  --Lime-hover: rgba(215, 218, 47, 0.5);
  --Lime-light: rgba(215, 218, 47, 0.2);
  --Red: hsl(4, 69%, 50%);

  /* ### Neutral */

  --White: hsl(0, 0%, 100%);
  --Slate-100: hsl(202, 86%, 94%);
  --Slate-300: hsl(203, 41%, 72%);
  --Slate-500: hsl(200, 26%, 54%);
  --Slate-700: hsl(200, 24%, 40%);
  --Slate-800: hsl(202, 50%, 20%);
  --Slate-900: hsl(202, 55%, 16%);
  --Slate-900-darker: hsl(202, 55%, 15%);
}

main,
section {
  min-height: 100vh;
}

section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.hidden {
  display: none;
}

.calculator-container {
  display: flex;
  flex-direction: column;
  color: var(--Slate-700);

  input:not([type="radio"]) {
    border-radius: 5px;
    border: 1px solid var(--Slate-300);
    height: 3rem;
    font-family: inherit;
    font-size: inherit;
    font-weight: 700;
    padding: 1rem 0 1rem 3.5rem;
    &:hover {
      border-color: var(--Slate-900);
    }

    &:focus {
      outline-color: var(--Lime);
    }

    &:invalid {
      border-color: var(--Red);
    }
  }

  .input-container {
    position: relative;
    width: 100%;
    margin-top: 1rem;

    &:has(input:not([type="radio"]):focus) > .inner-label {
      background-color: var(--Lime);
      color: var(--Slate-900);
    }

    &:has(input:not([type="radio"]):invalid) > .inner-label {
      background-color: var(--Red);
      color: var(--White);
    }

    &:has(input:not([type="radio"]):invalid) + .required-text {
      display: block;
    }
  }

  .required-text {
    color: var(--Red);
    font-size: 0.8rem;
    font-weight: 500;
    margin-top: 0.75rem;
  }

  .inner-label {
    position: absolute;
    place-content: center;
    top: 1px;
    background-color: var(--Slate-100);
    width: auto;
    height: calc(3rem - 2px);
    padding: 0 1rem;
    font-weight: 700;
    font-size: 1rem;

    &.left {
      left: 1px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    &.right {
      right: 1px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;

      & + input[type="number"] {
        padding-left: 1rem;
      }
    }
  }

  .radio-container {
    border-radius: 5px;
    border: 1px solid var(--Slate-900);
    display: grid;
    align-items: center;
    grid-template-columns: 1em auto;
    align-content: center;
    gap: 0.5em;
    height: 3rem;
    margin-top: 1rem;
    color: var(--Slate-900);
    font-weight: 700;
    cursor: pointer;
    padding-left: 1rem;

    &:hover {
      border-color: var(--Lime);
    }

    &:has(input[type="radio"]:checked) {
      background-color: var(--Lime-light);
      border-color: var(--Lime);
    }

    input[type="radio"] {
      appearance: none;
      width: 20px;
      height: 20px;
      border: 0.15em solid var(--Slate-900);
      border-radius: 50%;
      margin: 0;
      transform: translateY(-0.075em);
      display: grid;
      place-content: center;

      &:checked {
        border: 0.15em solid var(--Lime);
      }
    }

    input[type="radio"]::before {
      content: "";
      width: 0.65em;
      height: 0.65em;
      border-radius: 50%;
      transform: scale(0);
      transition: 120ms transform ease-in-out;
      box-shadow: inset 1em 1em var(--Lime);
    }

    input[type="radio"]:checked::before {
      transform: scale(1.3);
    }
  }

  button {
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    &#calculate {
      background-color: var(--Lime);
      border-radius: 100px;
      font-weight: 700;
      font-size: 1rem;
      color: var(--Slate-900);
      padding: 1rem;
      &:hover {
        background-color: var(--Lime-hover);
      }
    }
  }
}

.calculator-container > .calculator {
  padding: 2rem 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .term-and-rate {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
}

.calculator-container > .calculator > .title-row {
  h2 {
    color: var(--Slate-900);
  }

  button {
    margin-top: 0.5rem;
    text-decoration: underline;
    color: var(--Slate-700);
    &:hover {
      font-weight: 700;
    }
  }
}

.results {
  flex: 1;
  background-color: var(--Slate-800);
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 4rem;
  margin-top: 2rem;

  h2 {
    color: var(--White);
    margin: 1rem 0;
    font-size: 1.7rem;
  }

  p {
    color: var(--Slate-500);
    font-weight: 700;
    line-height: 1.5;
  }

  .completed-results {
    text-align: start;
    padding: 0 1rem;

    .numeric-results {
      margin-top: 1rem;
      border-top: 4px solid var(--Lime);
      border-radius: 5px;
      background-color: var(--Slate-900-darker);
      box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);

      div {
        padding: 1rem;

        &.line {
          width: 90%;
          margin: 0 1rem;
          padding: 0;
          border-top: 1px solid var(--Slate-100);
          opacity: 0.2;
        }
      }

      p.monthly-repayment-amount {
        color: var(--Lime);
        font-size: 2.5rem;
      }

      p.total-repayment-amount {
        font-size: 1.5rem;
        color: var(--White);
      }
    }
  }
}

@media (min-width: 750px) {
  body {
    background-color: var(--Slate-100);
  }

  .calculator-container {
    flex-direction: row;
    align-items: center;
    background-color: var(--White);
    border-radius: 20px;

    .calculator,
    .results {
      padding: 2rem;
      width: 50%;
      max-width: 40rem;
    }

    .calculator {
      .title-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;
      }

      .term-and-rate {
        flex-direction: row;
      }

      button#calculate {
        align-self: flex-start;
        font-size: 0.9rem;
        padding: 1rem 2rem;
      }
    }

    .results {
      align-self: stretch;
      margin-top: 0;
      border-bottom-left-radius: 4rem;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;

      .completed-results {
        padding: 0;
      }

      h2 {
        margin-top: 0;
      }

      p {
        max-width: 50ch;
      }

      .empty-results {
        height: 100%;
        place-content: center;
      }

      .numeric-results {
        margin-top: 2rem;

        div {
          padding: 1.5rem;
        }

        p.monthly-repayment-amount {
          font-size: 3rem;
        }

        p.total-repayment-amount {
          font-size: 1.25rem;
        }
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB;;;;oBAIkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,WAAW;AACX;;;EAGE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,oDAAoD;EACpD,eAAe;;EAEf,cAAc;;EAEd,gBAAgB;;EAEhB,yBAAyB;EACzB,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,uBAAuB;;EAEvB,gBAAgB;;EAEhB,yBAAyB;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB;IACE,kBAAkB;IAClB,kCAAkC;IAClC,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B;MACE,8BAA8B;IAChC;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,wBAAwB;IAC1B;EACF;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;;IAEhB;MACE,6BAA6B;MAC7B,uBAAuB;IACzB;;IAEA;MACE,4BAA4B;MAC5B,mBAAmB;IACrB;;IAEA;MACE,cAAc;IAChB;EACF;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,kCAAkC;IAClC,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,eAAe;;IAEf;MACE,SAAS;MACT,2BAA2B;MAC3B,8BAA8B;IAChC;;IAEA;MACE,UAAU;MACV,4BAA4B;MAC5B,+BAA+B;;MAE/B;QACE,kBAAkB;MACpB;IACF;EACF;;EAEA;IACE,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;IAElB;MACE,yBAAyB;IAC3B;;IAEA;MACE,mCAAmC;MACnC,yBAAyB;IAC3B;;IAEA;MACE,gBAAgB;MAChB,WAAW;MACX,YAAY;MACZ,qCAAqC;MACrC,kBAAkB;MAClB,SAAS;MACT,+BAA+B;MAC/B,aAAa;MACb,qBAAqB;;MAErB;QACE,gCAAgC;MAClC;IACF;;IAEA;MACE,WAAW;MACX,aAAa;MACb,cAAc;MACd,kBAAkB;MAClB,mBAAmB;MACnB,uCAAuC;MACvC,qCAAqC;IACvC;;IAEA;MACE,qBAAqB;IACvB;EACF;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET;MACE,6BAA6B;MAC7B,oBAAoB;MACpB,gBAAgB;MAChB,eAAe;MACf,uBAAuB;MACvB,aAAa;MACb;QACE,mCAAmC;MACrC;IACF;EACF;AACF;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW;;EAEX;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,OAAO;EACP,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;;EAEhB;IACE,mBAAmB;IACnB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;;IAEf;MACE,gBAAgB;MAChB,iCAAiC;MACjC,kBAAkB;MAClB,yCAAyC;MACzC,0CAA0C;;MAE1C;QACE,aAAa;;QAEb;UACE,UAAU;UACV,cAAc;UACd,UAAU;UACV,sCAAsC;UACtC,YAAY;QACd;MACF;;MAEA;QACE,kBAAkB;QAClB,iBAAiB;MACnB;;MAEA;QACE,iBAAiB;QACjB,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;;IAEnB;;MAEE,aAAa;MACb,UAAU;MACV,gBAAgB;IAClB;;IAEA;MACE;QACE,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;MACrB;;MAEA;QACE,mBAAmB;MACrB;;MAEA;QACE,sBAAsB;QACtB,iBAAiB;QACjB,kBAAkB;MACpB;IACF;;IAEA;MACE,mBAAmB;MACnB,aAAa;MACb,+BAA+B;MAC/B,6BAA6B;MAC7B,gCAAgC;;MAEhC;QACE,UAAU;MACZ;;MAEA;QACE,aAAa;MACf;;MAEA;QACE,eAAe;MACjB;;MAEA;QACE,YAAY;QACZ,qBAAqB;MACvB;;MAEA;QACE,gBAAgB;;QAEhB;UACE,eAAe;QACjB;;QAEA;UACE,eAAe;QACjB;;QAEA;UACE,kBAAkB;QACpB;MACF;IACF;EACF;AACF","sourcesContent":["@font-face {\n  font-family: \"jakarta\";\n  src:\n    url(\"./assets/fonts/plusjakartasans-variablefont_wght-webfont.woff2\")\n      format(\"woff2\"),\n    url(\"./assets/fonts/plusjakartasans-variablefont_wght-webfont.woff\")\n      format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* RESETS */\n*,\n*:before,\n*:after {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nbutton {\n  border: none;\n  background: none;\n  font-family: inherit;\n  font-size: inherit;\n  width: auto;\n  cursor: pointer;\n}\n\nimg {\n  width: auto;\n}\n\nfieldset {\n  border: none;\n}\n\ninput {\n  cursor: pointer;\n  width: 100%;\n}\n\nlabel {\n  width: 100%;\n}\n\n/* Styles */\nbody {\n  min-height: 100vh;\n  font-family: \"jakarta\", Arial, Helvetica, sans-serif;\n  font-size: 16px;\n\n  /* ## Colors */\n\n  /* ### Primary */\n\n  --Lime: rgb(215, 218, 47);\n  --Lime-darker: rgb(166, 168, 35);\n  --Lime-hover: rgba(215, 218, 47, 0.5);\n  --Lime-light: rgba(215, 218, 47, 0.2);\n  --Red: hsl(4, 69%, 50%);\n\n  /* ### Neutral */\n\n  --White: hsl(0, 0%, 100%);\n  --Slate-100: hsl(202, 86%, 94%);\n  --Slate-300: hsl(203, 41%, 72%);\n  --Slate-500: hsl(200, 26%, 54%);\n  --Slate-700: hsl(200, 24%, 40%);\n  --Slate-800: hsl(202, 50%, 20%);\n  --Slate-900: hsl(202, 55%, 16%);\n  --Slate-900-darker: hsl(202, 55%, 15%);\n}\n\nmain,\nsection {\n  min-height: 100vh;\n}\n\nsection {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.hidden {\n  display: none;\n}\n\n.calculator-container {\n  display: flex;\n  flex-direction: column;\n  color: var(--Slate-700);\n\n  input:not([type=\"radio\"]) {\n    border-radius: 5px;\n    border: 1px solid var(--Slate-300);\n    height: 3rem;\n    font-family: inherit;\n    font-size: inherit;\n    font-weight: 700;\n    padding: 1rem 0 1rem 3.5rem;\n    &:hover {\n      border-color: var(--Slate-900);\n    }\n\n    &:focus {\n      outline-color: var(--Lime);\n    }\n\n    &:invalid {\n      border-color: var(--Red);\n    }\n  }\n\n  .input-container {\n    position: relative;\n    width: 100%;\n    margin-top: 1rem;\n\n    &:has(input:not([type=\"radio\"]):focus) > .inner-label {\n      background-color: var(--Lime);\n      color: var(--Slate-900);\n    }\n\n    &:has(input:not([type=\"radio\"]):invalid) > .inner-label {\n      background-color: var(--Red);\n      color: var(--White);\n    }\n\n    &:has(input:not([type=\"radio\"]):invalid) + .required-text {\n      display: block;\n    }\n  }\n\n  .required-text {\n    color: var(--Red);\n    font-size: 0.8rem;\n    font-weight: 500;\n    margin-top: 0.75rem;\n  }\n\n  .inner-label {\n    position: absolute;\n    place-content: center;\n    top: 1px;\n    background-color: var(--Slate-100);\n    width: auto;\n    height: calc(3rem - 2px);\n    padding: 0 1rem;\n    font-weight: 700;\n    font-size: 1rem;\n\n    &.left {\n      left: 1px;\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n    }\n\n    &.right {\n      right: 1px;\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n\n      & + input[type=\"number\"] {\n        padding-left: 1rem;\n      }\n    }\n  }\n\n  .radio-container {\n    border-radius: 5px;\n    border: 1px solid var(--Slate-900);\n    display: grid;\n    align-items: center;\n    grid-template-columns: 1em auto;\n    align-content: center;\n    gap: 0.5em;\n    height: 3rem;\n    margin-top: 1rem;\n    color: var(--Slate-900);\n    font-weight: 700;\n    cursor: pointer;\n    padding-left: 1rem;\n\n    &:hover {\n      border-color: var(--Lime);\n    }\n\n    &:has(input[type=\"radio\"]:checked) {\n      background-color: var(--Lime-light);\n      border-color: var(--Lime);\n    }\n\n    input[type=\"radio\"] {\n      appearance: none;\n      width: 20px;\n      height: 20px;\n      border: 0.15em solid var(--Slate-900);\n      border-radius: 50%;\n      margin: 0;\n      transform: translateY(-0.075em);\n      display: grid;\n      place-content: center;\n\n      &:checked {\n        border: 0.15em solid var(--Lime);\n      }\n    }\n\n    input[type=\"radio\"]::before {\n      content: \"\";\n      width: 0.65em;\n      height: 0.65em;\n      border-radius: 50%;\n      transform: scale(0);\n      transition: 120ms transform ease-in-out;\n      box-shadow: inset 1em 1em var(--Lime);\n    }\n\n    input[type=\"radio\"]:checked::before {\n      transform: scale(1.3);\n    }\n  }\n\n  button {\n    width: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n\n    &#calculate {\n      background-color: var(--Lime);\n      border-radius: 100px;\n      font-weight: 700;\n      font-size: 1rem;\n      color: var(--Slate-900);\n      padding: 1rem;\n      &:hover {\n        background-color: var(--Lime-hover);\n      }\n    }\n  }\n}\n\n.calculator-container > .calculator {\n  padding: 2rem 1rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n\n  .term-and-rate {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n}\n\n.calculator-container > .calculator > .title-row {\n  h2 {\n    color: var(--Slate-900);\n  }\n\n  button {\n    margin-top: 0.5rem;\n    text-decoration: underline;\n    color: var(--Slate-700);\n    &:hover {\n      font-weight: 700;\n    }\n  }\n}\n\n.results {\n  flex: 1;\n  background-color: var(--Slate-800);\n  text-align: center;\n  padding-top: 2rem;\n  padding-bottom: 4rem;\n  margin-top: 2rem;\n\n  h2 {\n    color: var(--White);\n    margin: 1rem 0;\n    font-size: 1.7rem;\n  }\n\n  p {\n    color: var(--Slate-500);\n    font-weight: 700;\n    line-height: 1.5;\n  }\n\n  .completed-results {\n    text-align: start;\n    padding: 0 1rem;\n\n    .numeric-results {\n      margin-top: 1rem;\n      border-top: 4px solid var(--Lime);\n      border-radius: 5px;\n      background-color: var(--Slate-900-darker);\n      box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);\n\n      div {\n        padding: 1rem;\n\n        &.line {\n          width: 90%;\n          margin: 0 1rem;\n          padding: 0;\n          border-top: 1px solid var(--Slate-100);\n          opacity: 0.2;\n        }\n      }\n\n      p.monthly-repayment-amount {\n        color: var(--Lime);\n        font-size: 2.5rem;\n      }\n\n      p.total-repayment-amount {\n        font-size: 1.5rem;\n        color: var(--White);\n      }\n    }\n  }\n}\n\n@media (min-width: 750px) {\n  body {\n    background-color: var(--Slate-100);\n  }\n\n  .calculator-container {\n    flex-direction: row;\n    align-items: center;\n    background-color: var(--White);\n    border-radius: 20px;\n\n    .calculator,\n    .results {\n      padding: 2rem;\n      width: 50%;\n      max-width: 40rem;\n    }\n\n    .calculator {\n      .title-row {\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 1rem;\n      }\n\n      .term-and-rate {\n        flex-direction: row;\n      }\n\n      button#calculate {\n        align-self: flex-start;\n        font-size: 0.9rem;\n        padding: 1rem 2rem;\n      }\n    }\n\n    .results {\n      align-self: stretch;\n      margin-top: 0;\n      border-bottom-left-radius: 4rem;\n      border-top-right-radius: 20px;\n      border-bottom-right-radius: 20px;\n\n      .completed-results {\n        padding: 0;\n      }\n\n      h2 {\n        margin-top: 0;\n      }\n\n      p {\n        max-width: 50ch;\n      }\n\n      .empty-results {\n        height: 100%;\n        place-content: center;\n      }\n\n      .numeric-results {\n        margin-top: 2rem;\n\n        div {\n          padding: 1.5rem;\n        }\n\n        p.monthly-repayment-amount {\n          font-size: 3rem;\n        }\n\n        p.total-repayment-amount {\n          font-size: 1.25rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
